import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { checkPrivileges } from "../../Helpers";
import Breadcrumb from "../common/Breadcrumb";
import Button from "../common/Button";
import DetailTabs from "../identity/DetailTabs";
import { getAccountDetailTabs } from "../identity/tabConfig";
import {
  deleteUpload,
  getAccountFiles,
  getAccountTerms,
  handleIdentityError,
} from "./accountsApi";
import UpdateUserDetail from "./accountDetail/Components/updateAccount";
import MonthlyTargets from "./accountDetail/Components/monthltyTargets";
import ContractManagement from "./accountDetail/Components/ContractManagement";
import Invoices from "./accountDetail/Components/Invoices";
import PaymentModule from "./accountDetail/Components/Payment";
import Vehicles from "./accountDetail/Components/Vehicles";
import AdditionalEmails from "./accountDetail/Components/AdditionalEmails";
import SyncVehicles from "./accountDetail/Components/SyncVehicles";
import { Serversettings } from "../ServerSettings/serverSettings";

const AccountDetailView = (props) => {
  const dispatch = useDispatch();
  const logInUser = useSelector((state) => state.logInUsers);
  const themecolors = useSelector((state) => state.themecolors);
  const ServerSetting = useSelector((state) => state.ServerSetting);
  const roles = useSelector((state) => state.roles);
  const users = useSelector((state) => state.users);
  const accounts = useSelector((state) => state.accounts);
  const cities = useSelector((state) => state.Cities?.cities);
  const [tab, setTab] = useState("edit");
  const [state, setState] = useState({
    selectedAccount: props.AccountSettings ? ServerSetting : props.selectItem,
    selectedUser: "",
    termsEnglish: "",
    termsArabic: "",
    termsobj: {},
    accountFilesData: [],
  });

  const patch = (next) => setState((prev) => ({ ...prev, ...next }));

  const refreshFiles = async () => {
    const files = await getAccountFiles(props.selectAccountId);
    patch({ accountFilesData: files || [] });
  };

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const [terms, files] = await Promise.all([
          getAccountTerms(props.selectAccountId).catch(() => null),
          getAccountFiles(props.selectAccountId).catch(() => []),
        ]);
        if (cancelled) return;
        patch({
          selectedAccount: props.AccountSettings ? ServerSetting : props.selectItem,
          termsEnglish:
            terms?.data?.attributes?.termsEnglish ||
            terms?.attributes?.termsEnglish ||
            "",
          termsArabic:
            terms?.data?.attributes?.termsArabic ||
            terms?.attributes?.termsArabic ||
            "",
          termsobj: terms?.data ? terms : terms ? { data: terms } : {},
          accountFilesData: files || [],
        });
      } catch (error) {
        if (!cancelled) toast.error(handleIdentityError(error, props.translate));
      }
    };
    if (props.selectAccountId) load();
    return () => {
      cancelled = true;
    };
  }, [props.selectAccountId, props.AccountSettings, props.selectItem, ServerSetting, props.translate]);

  const removeAccountFile = async (mediaId) => {
    await deleteUpload(mediaId);
    refreshFiles();
  };

  const shared = {
    ...props,
    ...state,
    dispatch,
    logInUser,
    themecolors,
    roles,
    users,
    accounts,
    cities,
    ServerSetting,
    UpdateSelectedItem: (item) => patch({ selectedUser: item, selectedAccount: item }),
    updateSelectedAccount: (item) => patch({ selectedAccount: item }),
    accountFilesData: state.accountFilesData,
    removeAccountFile,
    getAccountFilesData: refreshFiles,
    translate: props.translate,
  };

  const tabs = getAccountDetailTabs({ selectedAccount: state.selectedAccount,logInUser });
  const tabName =
  tab==="additionalEmails"?"Additional Emails":
    tab === "contractManagement"
      ? "contractManagement"
      : tab === "Invoices"
        ? "Invoices"
        : tab === "payment"
          ? "Payment"
          : "Edit";

  return (
    <div>
      <Breadcrumb
        itemName={props.selectItemName}
        tabName={tabName}
        onClose={props.onClose}
        moduleName={props.translate("accountDetails")}
        backLink={
          !props.AccountSettings ? (
            <Button size="small" onClick={props.onClose}>
              {props.translate("sharedBack")}
            </Button>
          ) : null
        }
      />
      <DetailTabs
        value={tab}
        onChange={(event, value) => setTab(value)}
        tabs={tabs}
        translate={props.translate}
        themecolors={themecolors}
        paperStyle={{ overflow: "auto" }}
      >
        {tab === "edit" && <UpdateUserDetail {...shared} />}
        {tab === "monthlyTargets" && <MonthlyTargets {...shared} />}
        {tab === "contractManagement" && <ContractManagement {...shared} />}
        {tab === "Invoices" && (
          <Invoices invoiceType={props.value} {...shared} />
        )}
        {tab === "payment" && <PaymentModule {...shared} />}
        {tab === "vehicles" && <Vehicles {...shared} />}
        {tab === "settings" && (
          <Serversettings
            updateOtherServerSetting
            otherServerSetting={state.selectedAccount}
            updateSelectedAccount={(item) => patch({ selectedAccount: item })}
            translate={props.translate}
            getMoreAccounts={props.getMoreAccounts}
          />
        )}
        {tab === "syncVehicle" && checkPrivileges("vehicleIntegrateMultiple") && (
          <SyncVehicles invoiceType={props.value} {...shared} />
        )}
        {tab === "additionalEmails" && <AdditionalEmails {...shared} />}
      </DetailTabs>
    </div>
  );
};

export default AccountDetailView;
export const ViewAccountDetail = AccountDetailView;
